/*****************************************************************
 *  CUSTOMER BUTLER - THE LOOK OF EACH EVENT FROM THE OTHER BUTLERS *
 *  File: apps/web/src/pages/customer/suiteEventLooks.js           *
 *  What it does: the ONE place that says which icon an event from *
 *  another Butler shows on a customer's timeline, and whether it  *
 *  carries a chip of its own (a word and an icon) beside its      *
 *  words. Every screen that draws these rows asks here:           *
 *    the Timeline History (recordActivities.js)                   *
 *    the Open / Closed Activities columns (ZohoRelatedBlocks.js)  *
 *    the clean look's "From the other Butlers" list and the       *
 *    CRM Setup waiting list (SuiteTimeline.js)                    *
 *  Reads: nothing.  Writes: nothing.                              *
 *****************************************************************/

/*****************************************************************
 *  TABLE OF CONTENTS                                              *
 *  SECTION 1 - THE RULING                                         *
 *  SECTION 2 - THE LOOKS, BY EVENT NAME                           *
 *  SECTION 3 - FINDING ONE EVENT'S LOOK                           *
 *****************************************************************/

/*****************************************************************
 *  SECTION 1 - THE RULING                                         *
 *  WHY (2026-10-15, Fable/James, BACKLOG 317): "The pulled-back   *
 *  event must show on the customer's timeline as its own row with *
 *  its own icon and plain words." Colour is never the only sign:  *
 *  a pulled-back row has the turning-back arrow AND the chip      *
 *  "Pulled back" beside its words.                                *
 *  The words themselves come from the server (the door's source   *
 *  file names each event's plain words), so they are not here.    *
 *****************************************************************/

/*****************************************************************
 *  SECTION 2 - THE LOOKS, BY EVENT NAME                           *
 *  icon: a name from customerIcons.js                             *
 *  chip: { tone, icon, word } shown beside the words, or null     *
 *****************************************************************/

const EVENT_LOOKS = Object.freeze({
  'report.report.sent': { icon: 'file', chip: null },
  'report.report.resent': { icon: 'file', chip: null },
  'report.report.approved': { icon: 'check', chip: null },
  'report.report.marked_sent': { icon: 'check', chip: null },
  'report.report.send_pulled_back': {
    icon: 'undo',
    chip: { tone: 'warn', icon: 'undo', word: 'Pulled back' },
  },
});

// Any event with no look of its own keeps the plain link icon it had.
const PLAIN_EVENT_LOOK = Object.freeze({ icon: 'link', chip: null });

/*****************************************************************
 *  SECTION 3 - FINDING ONE EVENT'S LOOK                           *
 *****************************************************************/

/* ---- lookForEvent(eventName) -----------------------------------
   In: an event name, e.g. 'report.report.send_pulled_back'.
   Out: { icon, chip } - always an answer, never undefined.       */
export function lookForEvent(eventName) {
  const cleanName = String(eventName || '');
  const hasItsOwnLook = Object.prototype.hasOwnProperty.call(EVENT_LOOKS, cleanName);

  if (hasItsOwnLook) {
    return EVENT_LOOKS[cleanName];
  }

  return PLAIN_EVENT_LOOK;
}

export default lookForEvent;
